import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTopicByUser } from "@store/action/smartend/TopicAction";
import { Link, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from "react-share";
import BreadCrumbs from "@components/breadcrumbs/index1";
import Filter from "../Filter";
import classnames from "classnames";
import ReactPaginate from "react-paginate";

const Smartend = () => {
  const [activeView, setActiveView] = useState("list");
  const { t } = useTranslation();
  const shareUrl = window.location.origin;
  const dispatch = useDispatch();
  const store = useSelector((state) => state.NewsReducer);
  const news = store.topic_by_user;
  const count = Number(Math.ceil(news.recordsTotal / news.perPage));
  const myURL = useRouteMatch().url;
  const lang = localStorage.getItem("lang") || "en";
  const lang1 = lang.substring(1, lang.length - 1) || "en";
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
  };
  const { webmasterTitle, user_id } = useRouteMatch().params;
  useEffect(() => {
    dispatch(
      getTopicByUser(webmasterTitle, user_id, {
        page: currentPage,
        per_page: 5,
      })
    );
  }, [dispatch, webmasterTitle, user_id, currentPage]);

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={t(webmasterTitle)} />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter t={t} dispatch={dispatch} setCurrentPage={() => {}} />
            <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 shop_sidebar">
              <div className="row">
                <div className="col-md-12 d-none d-sm-none d-md-block d-lg-block">
                  <div className="filter-area ms_cover">
                    <div className="list-grid">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-bs-toggle="tab"
                            onClick={() => setActiveView("grid")}
                          >
                            <i className="fas fa-th-large" />
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            data-bs-toggle="tab"
                            onClick={() => setActiveView("list")}
                          >
                            <i className="fas fa-list-ul" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {news?.data?.length
                  ? news?.data.map((item, i) => {
                      return (
                        <div
                          key={i}
                          className={
                            activeView === "list"
                              ? "col-lg-12 col-md-12 col-sm-12 col-12"
                              : "col-xl-4 col-lg-4 col-md-4 col-sm-12"
                          }
                        >
                          <div
                            className={
                              activeView === "list"
                                ? "featured_artist_list shop_video_wrapper shop_list_img_wrapper ms_cover"
                                : "featured_artist_list shop_video_wrapper  ms_cover"
                            }
                          >
                            <Link to={`${myURL}/${item.id}`}>
                              <img
                                className="img-fluid card-img-top"
                                src={item.photo_file && item.photo_file}
                                alt={item.name}
                              />
                            </Link>
                            <div className="featured_artist_detail shop_featured_artist">
                              <p>
                                <Link to={`${myURL}/${item.id}`}>
                                  {item.title}
                                </Link>
                              </p>
                              <p className="various_artist_text">
                                {t("Description :")} {item.description}
                              </p>
                              <p>
                                {new Date(item.date).toLocaleString(
                                  `${lang1}-US`,
                                  {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  }
                                )}
                              </p>
                            </div>
                            <div
                              className={classnames("shop_rating_section", {
                                open: activeView !== "list",
                              })}
                            >
                              <ul
                                className="blog-icon-podcast"
                                style={{ textAlign: "center" }}
                              >
                                <li>
                                  <FacebookShareButton
                                    url={`${shareUrl}/dataNews/${webmasterTitle}/topics/${item.id}`}
                                  >
                                    <FacebookIcon size={30} round={true} />
                                  </FacebookShareButton>
                                </li>

                                <li>
                                  <TwitterShareButton
                                    url={`${shareUrl}/dataNews/${webmasterTitle}/topics/${item.id}`}
                                  >
                                    <TwitterIcon size={30} round={true} />
                                  </TwitterShareButton>
                                </li>
                                <li>
                                  <WhatsappShareButton
                                    url={`${shareUrl}/dataNews/${webmasterTitle}/topics/${item.id}`}
                                  >
                                    <WhatsappIcon size={30} round={true} />
                                  </WhatsappShareButton>
                                </li>
                                <li>
                                  <FacebookMessengerShareButton
                                    url={`${shareUrl}/dataNews/${webmasterTitle}/topics/${item.id}`}
                                  >
                                    <FacebookMessengerIcon
                                      size={30}
                                      round={true}
                                    />
                                  </FacebookMessengerShareButton>
                                </li>
                              </ul>
                              <div className="lang_apply_btn">
                                <Link
                                  to={`/dataNews/${webmasterTitle}/topics/${item.id}`}
                                >
                                  {t("read more")}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : t("No Results")}
                <div className="blog_pagination_section ms_cover">
                  <ReactPaginate
                    previousLabel={
                      <p className="prev">
                        <i className="flaticon-left-arrow" />
                      </p>
                    }
                    nextLabel={
                      <p className="next">
                        <i className="flaticon-right-arrow" />
                      </p>
                    }
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={2}
                    pageCount={count || 1}
                    breakLabel="..."
                    activeClassName="third_pagger"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    onPageChange={(page) => handlePageChange(page)}
                    pageClassName={"page-item"}
                    containerClassName={
                      "pagination react-paginate justify-content-end p-1"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Smartend;
